import axiosInstance from "./axiosInstance";

// GET /api/boards/ — user ke saare boards
export const getBoards = async () => {
  const response = await axiosInstance.get("/boards/");
  return response.data?.results || response.data || [];
};

// POST /api/boards/ — naya board banao
export const createBoard = async (name, isPrivate) => {
  const response = await axiosInstance.post("/boards/", {
    name,
    is_private: isPrivate,
  });
  return response.data;
};

// POST /api/boards/{boardId}/save/ — post save karo board mein
export const saveToBoard = async (boardId, postId) => {
  const response = await axiosInstance.post(`/boards/${boardId}/save/`, {
    post_id: postId,
  });
  return response.data;
};

// DELETE /api/boards/{boardId}/remove/{postId}/ — post remove karo board se
export const removeFromBoard = async (boardId, postId) => {
  const response = await axiosInstance.delete(
    `/boards/${boardId}/remove/${postId}/`
  );
  return response.data;
};